export class ViewSource {

    constructor(key: string, viewname: string) {
        this.key = key;
        this.viewName = viewname;
    }

    viewName: string;

    key: string;
}
